export const PAGE_SIZE: number = 10;
export const DATE_FORMAT: string = 'MM/dd/y';